export default "__VITE_ASSET__Dq7$Qdp___"